import { P2GBox } from '@parcel2go/core-ui';
import { AppCard } from '~/components/card/app-card';

interface props {
  children: React.ReactNode;
}

export default function SmartSendItemContainer(props: props) {
  return (
    <P2GBox mb={2}>
      <AppCard>{props.children}</AppCard>
    </P2GBox>
  );
}
